import { useQuery, QueryFunction } from 'react-query';
import { getAllVehicleTypes, VehicleType, GetVehiclesTypesQueries } from '../../services/apiSLTP/materials/vehiclesTypes';

type UseVehiclesTypesQueryOptions = {
    queries?: GetVehiclesTypesQueries;
};

const getVehicleTypes: QueryFunction<VehicleType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseVehiclesTypesQueryOptions];
    const { queries } = options;
    const response = await getAllVehicleTypes(queries);
    return response.data;
};

export const useVehicleTypesQuery = (options: UseVehiclesTypesQueryOptions) => {
    return useQuery(['vehicleTypes', options], getVehicleTypes);
};
